export default "__VITE_ASSET__0e558948__"